import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/connexion"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setToken(data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", "/app");
        navigate(data.user.exam_id || data.user.role !== "student" ? "/app" : "/bienvenue", { replace: true });
      } catch {
        setError("La connexion Google a échoué. Réessayez.");
        setTimeout(() => navigate("/connexion"), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="grid min-h-screen place-items-center bg-cream">
      <div className="text-center">
        <div className="animate-pulse"><Logo size={48} /></div>
        <p className="mt-4 text-sm text-muted-foreground">
          {error || "Connexion en cours..."}
        </p>
      </div>
    </div>
  );
}
